function getUrl () {
  var apiUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//a1.easemob.com'
  var xmppUrl = '//im-api-v2.easemob.com/ws'
  if (window.location.href.indexOf('www.test.com') !== -1) {
    apiUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//a1.easemob.com'
    xmppUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//im-api-v2.easemob.com/ws'
  } else if (window.location.href.indexOf('172.17.1.95') !== -1) {
    apiUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//a1.easemob.com'
    xmppUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//im-api-v2.easemob.com/ws'
  } else if (window.location.href.indexOf('localhost') !== -1) {
    apiUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//a1.easemob.com'
    xmppUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//im-api-v2.easemob.com/ws'
  }
  return {
    apiUrl: apiUrl,
    xmppUrl: xmppUrl
  }
}

var config = {
  xmppURL: getUrl().xmppUrl,
  apiURL: getUrl().apiUrl,
  appkey: '1107200315113837#chinesebridge', // 1107200315113837#chinesebridge //1147201029181994#demo
  Host: 'easemob.com',
  https: true,
  isHttpDNS: false,
  isMultiLoginSessions: true,
  isWindowSDK: false,
  isSandBox: false,
  isDebug: true,
  isStropheLog: false,
  autoReconnectNumMax: 5,
  autoReconnectInterval: 2,
  isWebRTC: true, // window.RTCPeerConnection && /^https\:$/.test(window.location.protocol),
  i18n: 'us',
  isAutoLogin: true,
  p2pMessageCacheSize: 500,
  delivery: true,
  groupMessageCacheSize: 200,
  loglevel: 'ERROR',
  enableLocalStorage: true
}
export default config
